export default __webpack_public_path__ + "static/media/bosta.c0e658a4.svg";